import PropTypes from 'prop-types';
import { HotelProviders, HotelProvidersLabels } from '../../../../../constants';

const HotelProviderLabel = ({ itinerary }) => {
  const provider = itinerary?.hotel?.priceProvider;
  const doShowProviderLabel = provider === HotelProviders.TABLET;

  return doShowProviderLabel ? (
    <div className="text-sm bg-preferenceLabelColor bg-opacity-10 text-preferenceLabelColor-0 inline-block px-3 py-1 rounded-lg">
      <span>{HotelProvidersLabels[provider] || provider} Hotel</span>
    </div>
  ) : (
    <></>
  );
};

HotelProviderLabel.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default HotelProviderLabel;
